import { render, staticRenderFns } from "./BoAuth.vue?vue&type=template&id=34aaba3e&"
import script from "./BoAuth.vue?vue&type=script&lang=js&"
export * from "./BoAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports